import React from 'react';
import Box from '@amzn/awsui-components-core/box';
import { DAS_FINSUITE_SLACK_CHANNEL_URL, SLACK_ICON_URL } from 'src/constants/AppConstants';
import 'src/styles/_footer-quote.scss';

export const FooterQuote: React.FC = () => {
  return (
    <div className="footer-quote">
      <Box variant="p" fontSize="body-s" color="text-body-secondary" margin="n">
        <span className="footer-quote__text">
          <Box variant="span" fontWeight="bold">
            # FinSuite
          </Box>{' '}
          — Invented in <span className="footer-quote__city">San Francisco</span>. Designed in <span className="footer-quote__city">Seattle</span>.
          Reimagined in <span className="footer-quote__city">Bangalore</span> by AD3.
        </span>
      </Box>
      <a
        href={DAS_FINSUITE_SLACK_CHANNEL_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Join #das-finsuite-interest Slack channel"
        className="footer-quote__slack-link"
      >
        <img src={SLACK_ICON_URL} alt="Slack" className="footer-quote__slack-icon" />
      </a>
    </div>
  );
};
